<template>
  <div v-if="visible" class="p-4">
    <h4 class="mb-3">Kopie anfordern</h4>
    <p class="text-muted mb-4">
      Möchtest du eine Kopie der Quittung per E-Mail erhalten?
    </p>

    <div class="row justify-content-center">
      <div class="col-md-6">
        <label for="recipientEmailCopy" class="form-label">Empfänger-E-Mail (optional)</label>
        <input
          type="email"
          class="form-control"
          id="recipientEmailCopy"
          v-model="formData.recipientEmail"
          placeholder="empfaenger@beispiel.de"
          :class="{ 'is-invalid': errors.recipientEmail }"
          @input="onEmailInput"
          @blur="validateRecipientEmail"
        />
        <div class="invalid-feedback" v-if="errors.recipientEmail">
          {{ errors.recipientEmail }}
        </div>
        <div class="form-text">
          Eine Kopie der Quittung wird an diese E-Mail-Adresse gesendet
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-4">
      <div class="col-md-6">
        <div class="alert alert-info">
          <font-awesome-icon icon="info-circle" class="me-2" />
          <strong>Hinweis:</strong> Für dieses Design ist keine Signatur erforderlich.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import { ReceiptWizardSymbol } from '../../tokens'

const wizard = inject(ReceiptWizardSymbol)

if (!wizard) {
  throw new Error('StepCopy requires ReceiptWizard context')
}

const visible = computed(() => wizard.isCurrentStep('Kopie'))
const formData = wizard.formData
const errors = wizard.errors
const validateRecipientEmail = wizard.validateRecipientEmail
const clearFieldError = wizard.clearFieldError

const onEmailInput = () => {
  clearFieldError('recipientEmail')
  validateRecipientEmail()
}
</script>
